import React from "react";
import { useNavigate } from "react-router-dom";
import { createServerPlan } from "src/actions/mine_craft/serverPlansActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewError, setNewParams, ServerPlanInterface } from "src/store/mine_craft/serverPlansSlice";

import DrawerRight from "src/componets/DrawerRight";
import AlertBlock from "src/componets/AlertBlock";
import Form from './_partials/_Form';

const New = () => {
  const navigate  = useNavigate();
  const dispatch  = useAppDispatch();
  const newParams = useAppSelector(state => state.mineCraft.serverPlans.newParams);
  const error     = useAppSelector(state => state.mineCraft.serverPlans.newError);

  function onCloseError() {
    dispatch(setNewError(null));
  }

  function onClose() {
    dispatch(setNewParams(null));
  }

  function onFinish(data: ServerPlanInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: object) {
    const resultAction = await dispatch(createServerPlan(data));

    if (createServerPlan.fulfilled.match(resultAction)) {
      onClose();
      navigate(0);
    }
  }

  return (
    <DrawerRight
      open={!!newParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-new-server-plan'>
        <h6 className="v-content-label">Create Server Plan</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form onFinish={onFinish} params={newParams} />
      </div>
    </DrawerRight>
  )
}

export default New;
